export const DEFAULTS = {
  config: {
    createHref: (decoratedText: $TSFixMe) =>
      `/search/posts?query=${encodeURIComponent('#')}${decoratedText}`,
    onClick: (event: $TSFixMe) => {
      event.preventDefault();
    },
  },
};
